import { render, staticRenderFns } from "./CapacityDashboard.vue?vue&type=template&id=a96fe6f2&scoped=true&"
import script from "./CapacityDashboard.vue?vue&type=script&lang=js&"
export * from "./CapacityDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CapacityDashboard.vue?vue&type=style&index=0&id=a96fe6f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96fe6f2",
  null
  
)

export default component.exports